import React, { Component } from 'react';
import './Presents.css';
import { connect } from 'react-redux';
import { getAllPresents, presentsFiltered, setManualInvoiceId } from '../../services/presents';
import { formatDate } from '../../utils/formatDate';
import { Input, Dialog, Button } from 'element-react';
import Link from 'react-router-dom/Link';

class Presents extends Component {
  constructor(props) {
    super(props);
    this.state = {
      presents: [],
      presentId: undefined,
      loading: true,
      manualInvoicePresentId: null,
      showManualInvoiceGenerator: false
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getAllPresents();
      this.setState({ presents: data, loading: false });
    } catch (err) {
      console.error(err);
    }
  }

  async idChange(id) {
    this.setState({ loading: true, presentId: id });
    const { data } = await presentsFiltered([{ label: 'presentId', value: id }]);
    this.setState({ presents: data, loading: false });
  }

  renderFilters() {
    return (
      <div className="presentsFilters">
        <div className="presentsFilter">
          <p>Identificador de reserva:</p>
          <Input placeholder="Escribir ..." value={this.state.presentId} onChange={val => this.idChange(val)} />
        </div>
      </div>
    );
  }

  onIdChange = async (event) => {
    try {
      const newInvoiceValue = ('000000' + event.target.value).slice(-6);
      this.setState({ manualInvoiceId: newInvoiceValue });
    } catch (err) {
      alert('Error');
    }
  }

  generateInvoiceIdForPresent = async () => {
    try {
      await setManualInvoiceId(this.state.manualInvoicePresentId, this.state.manualInvoiceId);
      const presents = this.state.presents.map((present) => {
        if (present.presentId === this.state.manualInvoicePresentId) {
          return {
            ...present,
            lastInvoiceId: this.state.manualInvoiceId
          }
        }

        return present;
      });
      this.setState({ showManualInvoiceGenerator: false, presents });
    } catch (err) {
      console.error(err);
    }
  }

  renderInvoiceIdGenerator = () => (
    <Dialog
      title={`Generar manualmente id de factura para regala: ${this.state.manualInvoicePresentId}`}
      size="tiny"
      visible={this.state.showManualInvoiceGenerator}
      onCancel={() => this.setState({ showManualInvoiceGenerator: false })}
      lockScroll
    >
      <Dialog.Body>
        <label>
          <input
            type="number"
            name="name"
            value={this.state.manualInvoiceId}
            onInput={this.onIdChange}
          />
        </label>
        <span> -> A-{this.state.manualInvoiceId}</span>
        <h4 style={{ color: 'red' }}>IMPORTANTE: NO PODRÁS VOLVER A CAMBIARLO, TEN EN CUENTA EL NÚMERO ACTUAL DE LA ÚLTIMA FACTURA</h4>
      </Dialog.Body>
      <Dialog.Footer className="dialog-footer">
        <Button onClick={() => this.setState({ showManualInvoiceGenerator: false })}>Cancelar</Button>
        <Button type="primary" onClick={() => this.generateInvoiceIdForPresent()}>Confirmar</Button>
      </Dialog.Footer>
    </Dialog>
  );

  generateInvoiceId = async (present) => {
    this.setState({ showManualInvoiceGenerator: true, manualInvoicePresentId: present.presentId });
  }

  render() {
    return (
      <div className="presentsList">
        {this.renderFilters()}
        {this.renderInvoiceIdGenerator()}
        {
          this.state.loading
            ? <i className="el-icon-loading"></i>
            : this.state.presents.map((present, index) => (
              <div key={index} className="presentsItem">
                <div className="headerBooking">
                  <div>
                    {
                      present.bookingId
                        ? <p style={{ color: '#03543f', backgroundColor: '#def7ec', borderRadius: '.25rem', padding: '5px', display: 'inline-flex', fontWeight: 500 }}>Regala canjeado</p>
                        : <p style={{ color: '#42389d', backgroundColor: '#e5edff', borderRadius: '.25rem', padding: '5px', display: 'inline-flex', fontWeight: 500 }}>Regala sin canjear</p>
                    }

                    {/* Special present events */}
                    {present.bookingId
                      ? <div><i className="el-icon-warning"></i><Link to={`/reserves?bookingId=${present.bookingId}`}><button>Ver reserva canjeada</button></Link></div>
                      : <div><i className="el-icon-warning"></i><Link to={`/booking?presentId=${present.presentId}&pack=${present.pack}`}><button>Canjear reserva</button></Link></div>}

                    {/* Invoice */}
                    <h4>Identificador de regalo: {present.presentId}</h4>
                    <span>Identificador de factura: {
                      (present.lastInvoiceId || present.invoiceId)
                        ? 'A-' + ('000000' + (present.lastInvoiceId || present.invoiceId)).slice(-6)
                        : <button onClick={() => this.generateInvoiceId(present)}>Sin id, generar manualmente</button>
                    }
                    </span>

                    {/* Payment status */}
                    {present.paid === false && <p style={{ color: 'red' }}>NO PAGADO</p>}
                    {present.paid === true && <p style={{ color: 'green' }}>PAGADO</p>}

                    <h5>Pack: {present.pack}</h5>
                  </div>
                  <h5>Compra realizada: {formatDate(present.createdAt)}</h5>
                </div>
                <div className="contentBookingsItem">
                  <div className="bookingItem">
                    <h5>Dades de pagament</h5>
                    <p>Nom: {present.paymentDetails.name}</p>
                    <p>Telf: {present.paymentDetails.phone}</p>
                    <p>Email: {present.paymentDetails.email}</p>
                    <p>Comentari: {present.paymentDetails.comment}</p>
                  </div>
                  {
                    present.present
                    && <div className="bookingItem">
                      <h5>Dades de entrega</h5>
                      <p>{present.deliveryDetails.dir}</p>
                      <p>{present.deliveryDetails.cp}, {present.deliveryDetails.city}, {present.deliveryDetails.province}, {present.deliveryDetails.country}</p>
                    </div>
                  }
                  {
                    present.present
                    && <div className="bookingItem">
                      <h5>Pesonalitzat</h5>
                      <p>Noms: {present.deliveryDetails.names}</p>
                      <p>Missatge: {present.deliveryDetails.message}, {present.city}, {present.province}, {present.country}</p>
                    </div>
                  }
                  <div className="bookingItem">
                    <h5>Extres</h5>
                    <p>Sopar: {present.dinner ? 'Si' : 'No'}</p>
                    <p>Ampolla cava: {present.cava ? 'Si' : 'No'}</p>
                    <p>Xocolates: {present.xocolat ? 'Si' : 'No'}</p>
                    <p>Kit massatge: {present.kit ? 'Si' : 'No'}</p>
                  </div>
                </div>
              </div>
            ))
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  rooms: state.rooms
});

export default connect(
  mapStateToProps,
  null
)(Presents);



// WEBPACK FOOTER //
// ./src/components/Presents/Presents.js